import React, { ChangeEventHandler, KeyboardEventHandler } from 'react';
import './SearchRow.css';

interface IExhibitorStyleSearchProps {
  value: string;
  placeholder: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onSearch: () => void;
}

const ExhibitorStyleSearch = ({
  value,
  placeholder,
  onChange,
  onSearch,
}: IExhibitorStyleSearchProps) => {
  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSearch();
    }
  };

  return (
    <div className="exhibitor-style-search">
      <i className="search-icon" onClick={onSearch} />
      <input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default ExhibitorStyleSearch;
